module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForWin_pic9.6807dff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForWin/dataLeakInstallForWin_pic9.png
// module id = 500
// module chunks = 1